import { render } from "./Carousel.vue?vue&type=template&id=33ddb03e"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"wp-content/themes/nns-template/vue/components/Carousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33ddb03e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33ddb03e', __exports__)) {
    api.reload('33ddb03e', __exports__)
  }
  
  module.hot.accept("./Carousel.vue?vue&type=template&id=33ddb03e", () => {
    api.rerender('33ddb03e', render)
  })

}


export default __exports__